import { useApolloClient } from "@apollo/client";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Select from "@mostrans/web-components/components/base/Select";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import { Button, Divider, Icon } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  CreateRequirementByOpportunityID,
  DeleteRequirementByID,
  UpdateOpportunity,
  UpdateRequirementByID
} from "../../../../GQL/mutations";
import { GetOpportunityByID } from "../../../../GQL/queries";
import { valueInputJobDescAtoms, valueInputJobRequirementAtoms, valueInputOpportunity } from "../../../../shared/atoms/getValueInputAtoms";
import {
  useGetMasterDivision,
  useGetMasterKota
} from "../../../../shared/hooks/useGetMasterData";

function FormDetail(props) {
  const { detailJob, setDataDetailJob, fecthOpportunity, onClose } = props;
  const [openModalAddJobReq, setOpenModalAddJobReq] = useState(false);
  const [listMasterKota] = useGetMasterKota();
  const [listDivision] = useGetMasterDivision();
  const [editableJobReq, setEditableJobReq] = useState(false);
  const [inputOpportunity, setInputOpportunity] = useRecoilState(
    valueInputOpportunity
  );
  const { showConfirmationModal } = useConfirmationModal();
  const [valueUpdateJobreq, setValueUpdateJobreq] = useState(null);
  const client = useApolloClient();
  const resetInputOpportunity = useResetRecoilState(valueInputOpportunity);
  const resetInputJobDesc = useResetRecoilState(valueInputJobDescAtoms);
  const resetInputRequirement = useResetRecoilState(
    valueInputJobRequirementAtoms
  );
  const [editableInput, setEditableInput] = useState(true)
  const [errInput, setErrInput] = useState(false);
  const { title, division_id, description, location_id, job_level } =
    useRecoilValue(valueInputOpportunity);

  const refetchOpportunityByID = async () => {
    const opportunity = await GetOpportunityByID(client, detailJob.id);
    await setDataDetailJob(opportunity);
  };

  const handleOpenModalAddJobReq = () => {
    setOpenModalAddJobReq(true);
  };

  const handleCloseModalAddJobReq = () => {
    setOpenModalAddJobReq(false);
    setValueUpdateJobreq("");
  };

  const optionsKota = listMasterKota.map(function (kota) {
    return { value: kota.id, label: kota.nama };
  });

  const optionsDivision = listDivision.map(function (divisi) {
    return { value: divisi.id, label: divisi.division };
  });

  const optionsJobLevel = [
    { value: "Entry Level", label: "Entry Level" },
    { value: "Middle Level", label: "Middle Level" },
    { value: "Senior Level", label: "Senior Level" },
  ];

  const submitUpdateOpportunity = async () => {
    const inputOpportunity = {
      id: detailJob.id,
      title: title,
      description: description,
      location_id: location_id,
      division_id: division_id,
      job_level: job_level,
    };

    if (
      title === "" ||
      title === null ||
      description === "" ||
      description === null ||
      location_id === "" ||
      location_id === null ||
      division_id === "" ||
      division_id === null ||
      job_level === "" ||
      job_level === null
    ) {
      return setErrInput(true);
    }
    try {
      const response = await UpdateOpportunity(client, inputOpportunity);
      if (response.data.updateOpportunity.errMsg === "OK") {
        toast.success("Jobs Updated", {
          position: toast.POSITION.TOP_RIGHT,
        });
        resetInputOpportunity();
        resetInputJobDesc();
        resetInputRequirement();
        onClose();
        fecthOpportunity();
      } else {
        toast.error("Error Update", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteJobReq = async (requirementID) => {
    const show = await showConfirmationModal({
      contentText: "Are you sure to delete this Data?",
    });

    if (show.isConfirmed) {
      try {
        const responDelete = await DeleteRequirementByID(client, requirementID);
        if (responDelete.data.deleteRequirementByID.errMsg === "OK") {
          toast.success("Job Requirement Deleted", {
            position: toast.POSITION.TOP_RIGHT,
          });
          refetchOpportunityByID();
        } else {
          toast.error("Deleted Failed", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        alert(error);
        console.log(error, "Error Delete Job Desc");
      }
    }
  };

  const handleUpdateJobReq = async (jobreqcID) => {
    if (!valueUpdateJobreq) {
      return alert("Job Requirement is required");
    }
    const ParamUpdate = {
      id: parseInt(jobreqcID.id),
      job_requirement: valueUpdateJobreq,
    };
    try {
      const responUpdate = await UpdateRequirementByID(client, ParamUpdate);
      if (responUpdate.data.updateRequirementByID.errMsg === "OK") {
        toast.success("Job Requirement Updated", {
          position: toast.POSITION.TOP_RIGHT,
        });
        refetchOpportunityByID();
      } else {
        toast.error("Job Requirement Update Failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      alert(error);
      console.log(error);
    }
  };

  const submitAddJobReq = async () => {
    if (!valueUpdateJobreq) {
      return alert("Job Requirement is required");
    }
    const paramInput = {
      opportunity_id: parseInt(detailJob.id),
      job_requirement: valueUpdateJobreq,
    };

    try {
      const responInput = await CreateRequirementByOpportunityID(
        client,
        paramInput
      );
      if (responInput.data.createRequirementByOpportunityID.errMsg === "OK") {
        toast.success("Job Requirement Submitted", {
          position: toast.POSITION.TOP_RIGHT,
        });
        handleCloseModalAddJobReq();
        refetchOpportunityByID();
      } else {
        toast.error("Submit Failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      alert(error);
      console.log(error, "error tambah job requirement");
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {/* <ConfDeleteJobReq /> */}
      <div className="d-flex justify-content-between">
        <label htmlFor="" style={{ fontSize: 12 }}>
          General Info
        </label>
        <Button
          variant="text"
          size="small"
          onClick={() => setEditableInput((s) => !s)}
        >
          <Icon sx={{ color: "#0A8C4A", cursor: "pointer" }}>edit_note</Icon>{" "}
          Edit General Info
        </Button>
      </div>
      <Divider />
      <div className="form-row mb-1 mt-1">
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Title is required</p>}
            isError={errInput && !inputOpportunity.title}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Job Name
            </label>
            <Input
              type="text"
              disabled={editableInput}
              defaultValue={detailJob?.title}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  title: e.target.value,
                })
              }
            />
          </FormGroup>
        </div>
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={
              <p style={{ fontSize: 13 }}>Base Location is required</p>
            }
            isError={errInput && !inputOpportunity.location_id}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Base Location
            </label>
            <Select
              isDisabled={editableInput}
              options={optionsKota}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  location_id: e.value,
                })
              }
              defaultValue={{
                label: detailJob.Location?.nama,
                value: detailJob?.location_id,
              }}
            />
          </FormGroup>
        </div>
      </div>

      <div className="form-row mb-1">
        <div className="col-md-6">
          {" "}
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Division is required</p>}
            isError={errInput && !inputOpportunity.division_id}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Division
            </label>
            <Select
              isDisabled={editableInput}
              options={optionsDivision}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  division_id: e.value,
                })
              }
              defaultValue={{
                label: detailJob.Division?.division,
                value: detailJob?.division_id,
              }}
            />
          </FormGroup>
        </div>
        <div className="col-md-6">
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={<p style={{ fontSize: 13 }}>Job Level is required</p>}
            isError={errInput && !inputOpportunity.job_level}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Job Level
            </label>
            <Select
              isDisabled={editableInput}
              options={optionsJobLevel}
              onChange={(e) =>
                setInputOpportunity({
                  ...inputOpportunity,
                  job_level: e.value,
                })
              }
              defaultValue={{
                label: detailJob.job_level,
                value: detailJob?.job_level,
              }}
            />
          </FormGroup>{" "}
        </div>
      </div>
      <div className="form-row mb-1">
        <div className="col-md-12">
          {" "}
          <FormGroup
            isRequired
            placement="vertical"
            errorMessage={
              <p style={{ fontSize: 13 }}>Description is required</p>
            }
            isError={errInput && !inputOpportunity.description}
            showChildErrorSign
          >
            <label htmlFor="" style={{ fontSize: 12 }}>
              Description
            </label>
            <ReactQuill
              readOnly={editableInput}
              onChange={(e) =>
                setInputOpportunity({ ...inputOpportunity, description: e })
              }
              value={inputOpportunity.description}
            />
          </FormGroup>
        </div>
      </div>
      <div className="d-flex justify-content-end mb-1">
        <Button variant="contained" disabled={editableInput} onClick={submitUpdateOpportunity}>
          Save Changes
        </Button>
      </div>
      <div className="d-flex justify-content-between">
        <label htmlFor="" style={{ fontSize: 12 }}>
          Job Requirement
        </label>
        <Button
          variant="text"
          size="small"
          onClick={() => setEditableJobReq((s) => !s)}
        >
          <Icon sx={{ color: "#0A8C4A", cursor: "pointer" }}>edit_note</Icon>{" "}
          Edit Job Requirements
        </Button>
      </div>

      <Divider />

      {detailJob.Requirement.map((requirement, index) => (
        <div className="form-row mb-1 mt-2" key={requirement.id}>
          <div className="col-md-9">
            <FormGroup placement="vertical">
              <Input
                disabled={!editableJobReq ? true : false}
                defaultValue={requirement.job_requirement}
                multiline={2}
                onChange={(e) => setValueUpdateJobreq(e.target.value)}
              />
            </FormGroup>
          </div>
          <div className="col-md-3">
            {index ? (
              <Button
                disabled={!editableJobReq ? true : false}
                onClick={() => handleDeleteJobReq(requirement.id)}
                variant="outlined"
                size="small"
                color="error"
              >
                Delete
              </Button>
            ) : null}
            &nbsp;
            <Button
              disabled={!editableJobReq ? true : false}
              variant="contained"
              onClick={() => handleUpdateJobReq(requirement)}
              color="primary"
              size="small"
            >
              Save Changes
            </Button>
          </div>
        </div>
      ))}
      <div className="form-row">
        <Button onClick={handleOpenModalAddJobReq}>Add Job Requirement</Button>
      </div>
      <Dialog
        open={openModalAddJobReq}
        onClose={handleCloseModalAddJobReq}
        maxWidth={100}
      >
        <DialogTitle>Add new job requirement</DialogTitle>
        <DialogContent>
          <Input
            onChange={(e) => setValueUpdateJobreq(e.target.value)}
            multiline={2}
            style={{ width: "900px" }}
          />
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleCloseModalAddJobReq}>
            Cancel
          </Button>
          <Button onClick={submitAddJobReq}>Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default FormDetail;
